<div
  class="iot-platform-ui-placeholder-card flex h-full w-full flex-row items-center justify-center gap-1"
  [ngClass]="{
    'iot-platform-ui-placeholder-card--clickable': clickable(),
    'iot-platform-ui-placeholder-card--disabled': disabled()
  }"
>
  @if (icon()) {
    <mat-icon class="iot-platform-ui-placeholder-card-icon">{{ icon() }}</mat-icon>
  }
  <span class="iot-platform-ui-placeholder-card-text">{{ text() | translate | uppercase }}</span>
</div>
